let view = null;

export default {
	namespace: 'template-faq',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: FaqView } = await import(/* webpackChunkName: "faq-view" */ '../../templates/FaqView');
		view = new FaqView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
